module.exports = __webpack_public_path__ + "static/media/Melissa2.a0fc3a02.jpg";